export default __webpack_public_path__ + "static/media/rnr-sports-table-27.9180d87e.webp";